import React, { useContext } from "react";
import { useOnload } from "@utils/useOnLoad";
import DOMPurify from "isomorphic-dompurify";
import { Wrapper, Items, TextBox } from "./styles";
import { Context } from "@components/useContext/context";

const PolicyTimeline = ({ children, ...props }) => {
  const { showTimeline, od_only, odAndTp, isODFlow, product, bikeOdComp, vehicleAge, styles, actions } = props;
  const { on_load } = actions || {};
  useOnload({ on_load });
  const { isDesktop } = useContext(Context);

  if (!showTimeline) return null;

  let timeLineData;
  if(isODFlow && product === "bike") {
    timeLineData = bikeOdComp;
  } else if(vehicleAge === 1) {
    timeLineData = od_only;
  } else {
    timeLineData = odAndTp;
  }

  return (
    <Wrapper isDesktop={isDesktop} rowCount={timeLineData.year.length}>
      <Items className="year-column">
      <TextBox className="heading"
          style={{
            background: "#fff"
          }}
        >
          Year
        </TextBox>
        {timeLineData.year.map((item, index) => (
          <div key={index} className="year-item">
            <TextBox className="bold">{item.year}</TextBox>
            {item.desc && <TextBox className="desc">{item.desc}</TextBox>}
          </div>
        ))}
      </Items>

      <Items className="details-column">
        <TextBox className="heading">
          Own Damage
        </TextBox>
        {timeLineData.accidentalDamage.map((item, index) => {
          const isUpForRenewalOd =
            item.details && item.details.includes("Up for renewal");
          return (
            <div
              key={index}
              style={{
                backgroundColor: isUpForRenewalOd
                  ? "#FFF6F6"
                  : styles?.backgroundColor || "#F8F7FC",
                padding: "20px",
                margin: "10px 0 0",
                borderRadius: "8px",
                width: isDesktop ? "76%" : "70%"
              }}
            >
              {item.details && (
                <TextBox
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(item.details)
                  }}
                />
              )}
            </div>
          );
        })}
      </Items>

      <Items
        className="type-column"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <TextBox className="heading">
          Third-party
        </TextBox>
        {timeLineData.thirdParty.map((item, index) => {
          const isUpForRenewalTp =
            item.type && item.type.includes("Up for renewal");
          return (
            <div
              key={index}
              style={{
                backgroundColor: isUpForRenewalTp
                  ? "#FFF6F6"
                  : styles?.backgroundColor || "#F8F7FC",
                padding: item.type ? "20px" : "0px",
                margin: item.type ? "10px 0 0" : "0px",
                flexGrow: index === 0 ? "1" : "0",
                borderRadius: "8px",
                width: isDesktop ? "76%" : "70%"
              }}
            >
              {item.type && (
                <TextBox
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(item.type)
                  }}
                />
              )}
            </div>
          );
        })}
      </Items>
    </Wrapper>
  );
};

export default PolicyTimeline;
